// extracted by mini-css-extract-plugin
export default {"wrap":"DashboardLayout_wrap__0tbVI","content":"DashboardLayout_content__zmsq9","content_shift":"DashboardLayout_content_shift__5sv5o"};